import { RadioGroup as HeadlessUIRadioGroup } from '@headlessui/react';
import { CheckCircleIcon } from '@heroicons/react/solid';

function RadioGroup({ options, ...props }) {
    return (
        <HeadlessUIRadioGroup {...props}>
            <div className="flex gap-2">
                {options.map(({ value, label, disabled }) => (
                    <HeadlessUIRadioGroup.Option key={value} value={value} disabled={disabled}>
                        {({ checked }) => (
                            <div className={`${checked ? 'border-blue-400 bg-blue-100 text-blue-700' : 'cursor-pointer bg-gray-100 text-gray-500'} flex items-center gap-2 rounded border px-4 py-2`}>
                                {checked && <CheckCircleIcon className="w-5 h-5" />}
                                <span className={`${disabled ? 'line-through' : ''}`}>{label}</span>
                            </div>
                        )}
                    </HeadlessUIRadioGroup.Option>
                ))}
            </div>
        </HeadlessUIRadioGroup>
    );
}

export default RadioGroup;
